import React, {useState} from 'react';
import {Dimmer, Loader, Modal, Segment} from "semantic-ui-react";
import Dropzone from "react-dropzone";
import {apiGet, apiPost} from "../services/apiClient";
import SvgNew from "../components/SvgNew";
import {toast} from "react-toastify";

const AddFileModal = ({children, open, onClose: handleClose, reload, params, extensions}) => {

    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const clearData = () => {
        setError(null);
    }

    const onClose = () => {
        clearData();
        handleClose();
    }

    const renderDropzoneBody = () => {
        return (
            <div>
                <Dropzone
                    className='dropzone'
                    multiple={false}
                    onDrop={files => onDrop(files)}
                >
                    <div className="dropzone-description">
                        <svg width="45" height="40" viewBox="0 0 45 40" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd"
                                  d="M22.2221 0C27.9576 0 33.0109 3.69109 34.8331 8.98884C40.2531 9.72439 44.4442 14.3821 44.4442 19.9999C44.4442 22.7132 43.4575 25.3243 41.6664 27.3532C41.2264 27.8487 40.6153 28.1043 39.9998 28.1043C39.4776 28.1043 38.9531 27.9221 38.5287 27.5487C37.6109 26.7332 37.522 25.331 38.3353 24.4088C39.4087 23.1954 39.9998 21.6265 39.9998 19.9999C39.9998 16.3244 37.0087 13.3333 33.3332 13.3333H33.1109C32.0532 13.3333 31.1421 12.5866 30.9332 11.5488C30.1021 7.43329 26.4399 4.44442 22.2221 4.44442C18.0066 4.44442 14.3421 7.43329 13.5133 11.5488C13.3044 12.5866 12.391 13.3333 11.3333 13.3333H11.1111C7.43551 13.3333 4.44442 16.3244 4.44442 19.9999C4.44442 21.6265 5.03553 23.1954 6.11108 24.4088C6.92218 25.331 6.83552 26.7332 5.91552 27.5487C4.99553 28.3621 3.59109 28.271 2.77998 27.3532C0.986661 25.3243 0 22.7132 0 19.9999C0 14.3821 4.19109 9.72439 9.61106 8.98884C11.4355 3.69109 16.4888 0 22.2221 0ZM20.6779 18.4002C21.5535 17.5646 22.9379 17.5713 23.7935 18.4291L30.4601 25.0957C31.329 25.9646 31.329 27.369 30.4601 28.2379C30.0268 28.6712 29.4579 28.889 28.889 28.889C28.3201 28.889 27.7512 28.6712 27.3179 28.2379L24.4446 25.3646V37.7778C24.4446 39.0067 23.449 40 22.2224 40C20.9957 40 20.0002 39.0067 20.0002 37.7778V25.2357L17.1002 28.0357C16.218 28.8912 14.8113 28.8623 13.958 27.9801C13.1047 27.0957 13.1291 25.6912 14.0113 24.8379L20.6779 18.4002Z"
                                  fill="#135CA9"/>
                        </svg>
                        <div>
                            Перетащите файл в окно или <a>выберите</a>
                        </div>
                    </div>
                </Dropzone>
                <div className='max-size-text'>Расширения файлов: <span className='color_black'>{extensions}</span>
                </div>
                <div className='max-size-text'>Максимальный размер файла: <span className='color_black'>75 мб</span>
                </div>
            </div>
        );
    }

    const onDrop = (files) => {
        if (files && files.length > 0 && files[0].size <= 78643200) {
            setError(false);
            onSave(files[0]);
        } else setError({
            title: 'Размер файла превышает 75 Мб',
            message: 'Выберите другой файл'
        });
    }

    const onSave = (file) => {
        setLoading(true);
        setError(null);
        const errorTitle = 'Ошибка';
        const errorMessage = 'Повторите попытку или выберете другой файл.';

        const saveData = () => {
            let data = new FormData();
            data.append('file', file);
            apiPost(`${params.saveFullUrl? params.saveFullUrl : params.saveUrl}${params.saveUrl ? '/importExcel' : ''}`, data)
                .then((d) => {
                    if (d.successRows || d.totalRows) {
                        if (d.totalRows === d.successRows) {
                            onClose();
                            toast.success(d.message || 'Файл был успешно загружен')
                        } else {
                            setError({
                                title: `Успешно обработано ${d.successRows} записей из ${d.totalRows}`,
                                message: d.rowMessages.map(m => <div><b>{`(${m.rowNumber})`}</b> {m.message}</div>)
                            });
                        }
                    } else {
                        onClose();
                        toast.success(d.message || 'Файл был успешно загружен')
                    }
                    setLoading(false);
                    reload && reload();
                })
                .catch(err => {
                    setError({
                        title: errorTitle,
                        message: err.message || errorMessage
                    });
                    setLoading(false)
                });
        };

        saveData();
    }

    const downloadTemplate = (name) => {
        apiGet(`parcels/import/excel/${name}`)
            .then(data => {
                let fileUrl = getApiBaseUrl() + 'files/' + data.result;
                window.location.href = fileUrl;
            })
            .catch(err => {
                console.log(err)
            });
    }


    return (
        <Modal
            trigger={children}
            open={open}
            closeIcon
            size="small"
            onClose={onClose}
            className='file-modal'
        >
            <Modal.Header>
                {params.text || 'Загрузить документ'}
            </Modal.Header>
            <Modal.Content className='modal__content'>
                <Segment vertical>
                    <Dimmer active={loading} inverted>
                        <Loader size='medium'/>
                    </Dimmer>
                    {renderDropzoneBody()}
                    {
                        (params.template || params.templateUrl) && <a className='modal__template copy-string clickable'
                                                                      onClick={() => params.templateUrl && downloadTemplate(params.templateUrl)}
                                                                      href={params.template && `/files/${params.template}`}>
                            <SvgNew name={'excel'}/> <span>Шаблон файла загрузки с примером заполнения</span>
                        </a>
                    }
                    {error && <div className='modal-errors scroll-style'>
                        <div className='modal-error'>
                            <div className='modal-error__label'>{error.title}</div>
                            <div className='modal-error__description'>{error.message}</div>
                        </div>
                    </div>}
                </Segment>
            </Modal.Content>
        </Modal>
    );
};

export default AddFileModal;


// WEBPACK FOOTER //
// ./App/grids/addFileModal.jsx